import { FormattedMessage } from "react-intl";
import { Link, To } from "react-router";
import { ChevronRightIcon } from "@/icons";
import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalHeader,
  ResponsiveModalPortal,
  ResponsiveModalTitle,
} from "@/kit/ui/responsive-modal";

export interface VersionSubmissionLink {
  id: string;
  title: string;
  to: To;
}

export interface ViewSubmissionsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  submissions: VersionSubmissionLink[];
}

export default function ViewSubmissionsModal({
  open,
  onOpenChange,
  submissions,
}: ViewSubmissionsModalProps) {
  return (
    <ResponsiveModal open={open} onOpenChange={onOpenChange}>
      <ResponsiveModalPortal>
        <ResponsiveModalContent className="flex w-[80vw] flex-col gap-0 overflow-hidden p-0 lg:w-125">
          <ResponsiveModalHeader className="flex-none border-b border-grey-200 px-4 py-3 lg:p-6 lg:pb-4">
            <ResponsiveModalTitle className="text-start text-xl">
              <FormattedMessage defaultMessage="Submissions using this version" />
            </ResponsiveModalTitle>
          </ResponsiveModalHeader>
          <ul className="flex max-h-[60vh] flex-col overflow-y-auto p-2 lg:p-4">
            {submissions.map((submission) => (
              <li key={submission.id}>
                <Link
                  to={submission.to}
                  onClick={() => onOpenChange(false)}
                  className="flex flex-row items-center justify-between gap-3 rounded-lg px-3 py-2.5 hover:bg-grey-50"
                >
                  <span className="truncate font-medium text-grey-900">
                    {submission.title}
                  </span>
                  <ChevronRightIcon className="h-5 w-5 flex-none text-grey-400" />
                </Link>
              </li>
            ))}
          </ul>
        </ResponsiveModalContent>
      </ResponsiveModalPortal>
    </ResponsiveModal>
  );
}
